import { render } from "./sideCheckboxComponent.vue?vue&type=template&id=ed1ee79e&scoped=true"
import script from "./sideCheckboxComponent.vue?vue&type=script&lang=js"
export * from "./sideCheckboxComponent.vue?vue&type=script&lang=js"

import "./sideCheckboxComponent.vue?vue&type=style&index=0&id=ed1ee79e&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed1ee79e"]])

export default __exports__